import { useQuery } from '@tanstack/react-query'
import { formDataInit, defaultValuesProcessPayment } from '../utils/data'
import { useQueryClient } from '@tanstack/react-query'

export const setFormDataKey = 'formData'
export const useFormData = (initialValue = formDataInit) => {
  return useQuery({
    queryKey: [setFormDataKey],
    queryFn: () => initialValue,
    initialData: initialValue, // This ensures the data is never undefined

    // Importante: esto evita llamadas al servidor
    staleTime: Infinity
  })
}

export const setTiloPayPaymentData = 'tiloPayPaymentData'

export const useTiloPayPaymentData = () => {
  return useQuery({
    queryKey: [setTiloPayPaymentData],
    queryFn: () => defaultValuesProcessPayment,
    initialData: defaultValuesProcessPayment, // This ensures the data is never undefined

    // Importante: esto evita llamadas al servidor
    staleTime: Infinity
  })
}
